<template>
  <div v-if="form !== ''" class="mx-auto relative">
    <p
      class="absolute text-sm font-extralight leading-10 inline-block"
      :style="{
        left: leftBottomMargin + Math.round(10 * scaleFactor) + 'px',
        bottom:
          leftBottomMargin + Math.round(diamondLength * pixelFactor) + 'px',
      }"
    >
      {{ $n(diamondLength) }}mm
    </p>
    <p
      class="absolute text-sm font-extralight leading-10 inline-block"
      :style="{
        left:
          leftBottomMargin +
          Math.round(diamondWidth * pixelFactor) +
          Math.round(30 * scaleFactor) +
          'px',
        bottom: leftBottomMargin + 'px',
      }"
    >
      {{ $n(diamondWidth) }}mm
    </p>
    <img
      :src="
        host + '/img/diamonds/details/size/cut_' + form.toLowerCase() + '@4x.png'
      "
      :alt="form"
      class="absolute"
      :style="{
        left: leftBottomMargin + 'px',
        bottom: leftBottomMargin + 'px',
        width: Math.round(diamondWidth * pixelFactor) + 'px',
        height: Math.round(diamondLength * pixelFactor) + 'px',
      }"
    />
    <img
      :src="host + '/img/diamonds/details/size/ruler.png'"
      :style="{ width: boxWidth + 'px' }"
      alt="ruler"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DiamondDetailCaratSize",
  props: ["form", "carat", "diamondWidth", "diamondLength"],
  setup() {
    const rawPixelFactor = 12;
    const rawLeftBottomMargin = 120;
    const scaleFactor = 0.65;

    const pixelFactor = rawPixelFactor * scaleFactor;
    const leftBottomMargin = rawLeftBottomMargin * scaleFactor;

    const boxWidth = 400 * scaleFactor;

    const host = process.env.VUE_APP_HOST;

    return { host, boxWidth, scaleFactor, pixelFactor, leftBottomMargin };
  },
});
</script>

<style></style>
